import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Modal, Button, FormGroup, FormControl, ControlLabel, OverlayTrigger, Popover} from 'react-bootstrap';
import {
  showIngestModal,
  setIngestOperationTypes,
  setAddToWoIngestOperationTypes,
  changeStatusToAddFile,
  setNewFrameRate,
  showFrameRateModal,
  showIngestConfigChannelSetsModal,
  setFrameRate,
  clearFrameRateData,
  setErrorNumberFrameRateValue, showWoStepsAddToWoModal, showWoStepsModal, onGotoScreenToAddFile, saveIngestLkfsData
} from '../../actions';
import {buildWOInfo, isInvalidEncryptPassword, ENC_PASSWORD_MIN_LENGTH, getValueForOS} from '../../utils';
import {PathFieldStyledAdv} from './ModalStyled';
import styled from 'styled-components';
import Loader from '../../../../components/Loader';
import config from '../../../../../config';
import {confirmAlert} from 'react-confirm-alert';
import TextEllipsisAdvanced from '../../../../components/TextEllipsis/TextEllipsisAdvanced';
import RndModal from '../../../../components/modals/RndModal';
import ReportBugButton from "../../../../components/ReportBugButton";
import {showError} from "../../../../layouts/actions";
import WarningIcon from "../../../../components/icons/WarningIcon";

const OFFICE_BURBANK = config.officeFlag.BURBANK.toString();
const OFFICE_NEW_YORK = config.officeFlag.NEW_YORK.toString();
const OFFICE_NAMES = {
  [OFFICE_BURBANK]: 'Los Angeles (Burbank) Office',
  [OFFICE_NEW_YORK]: 'New York Office'
};
const OFFICE_SHORT_NAMES = {
  [OFFICE_BURBANK]: 'LA office',
  [OFFICE_NEW_YORK]: 'NY office'
};

class IngestModal extends Component {
  state = {
    ingestData: this.props.data,
    originalEncPasswords: {},
    encPasswordVisibility: {}
  };

  isInvalidEncPassword = office => {
    const {ingestData, originalEncPasswords} = this.state;
    if (!originalEncPasswords[office]) {
      return false;
    }
    const newPassword = ingestData[office].enc_password;
    return originalEncPasswords[office] !== newPassword && isInvalidEncryptPassword(newPassword);
  };

  handleChange = (office, index, checked) => {
    const {ingestData} = this.state;
    if (Array.isArray(ingestData[office])) {
      ingestData[office][index].value = checked;
    } else {
      ingestData[office].steps[index].value = checked;
    }
    this.setState({ingestData});
  };

  handleChangeEncPassword = (office, password) => {
    const {ingestData, originalEncPasswords} = this.state;
    if (!originalEncPasswords[office]) {
      originalEncPasswords[office] = ingestData[office].enc_password;
    }
    ingestData[office].enc_password = password || '';
    this.setState({ingestData, originalEncPasswords});
  };

  isVisibleEncPassword = (office) => {
    const {encPasswordVisibility} = this.state;
    return typeof encPasswordVisibility[office] === 'boolean' ? encPasswordVisibility[office] : false;
  };

  handleToggleEncPasswordVisibility = (office, isVisibleNow) => {
    this.setState({encPasswordVisibility: {...this.state.encPasswordVisibility, [office]: isVisibleNow}});
  };

  handleSend = () => {
    const {dispatch, item, onSetManualUpload, onStartIngestFromAssetManager, showIngestSettings, showFileSelection, lkfsModalState, workOrder} = this.props;
    const {ingestData, originalEncPasswords} = this.state;
    const {errorType, newFrameRate, frameRate, isEnable, audioChannelSetsData } = lkfsModalState;
    let officesWithEncPassword = [], officesWithChangedEncPassword = [], officesWithNotChangedEncPassword = [];
    Object.keys(ingestData).forEach(office => {
      const encPassword = Array.isArray(ingestData[office]) ? null : ingestData[office].enc_password;
      if (originalEncPasswords[office] || encPassword) {
        const steps = Array.isArray(ingestData[office]) ? ingestData[office] : ingestData[office].steps;
        if (Array.isArray(steps) && steps.some(step => step.label === 'Encrypt content' && step.value)) {
          officesWithEncPassword.push(office);
          if (originalEncPasswords[office] && originalEncPasswords[office] !== encPassword) {
            officesWithChangedEncPassword.push(office);
          } else {
            officesWithNotChangedEncPassword.push(office);
          }
        }
      }
    });

    let lkfsData = null;
    if (audioChannelSetsData && audioChannelSetsData.length > 0) {
      lkfsData = audioChannelSetsData.map(item => ({
        content_id: item.file.contentID,
        file_name: item.file.key,
        skip: item.data && item.data.skip,
        channel_sets: item.data && item.data.channelSets && item.data.channelSets.length > 0 ?
          `[${item.data.channelSets.map(set => set.channels).join(',')}]` :
          '',
        disabled_sets: item.data && item.data.channelSets ?
          item.data.channelSets.map((set, index) => set.enabled === false ? index : null)
            .filter(index => index !== null)
            .join(',') :
          ''
      }));
    }

    const onSend = () => {
      const hasLKFS = this.hasLKFS();
      if (hasLKFS && isEnable) {
        const woMemfisId = workOrder.woMemfisId;
        if (errorType !== null && errorType !== "success") {
          if (newFrameRate !== null) {
            dispatch(setFrameRate(newFrameRate, true, woMemfisId));
          } else if (frameRate !== null) {
            dispatch(setFrameRate(frameRate, false, woMemfisId));
          } else {
            dispatch(showError(`Frame Rate not set`));
            return;
          }
        } else if (errorType === "success") {
          if (newFrameRate !== null && frameRate !== null && newFrameRate !== frameRate) {
            dispatch(setFrameRate(newFrameRate, true, woMemfisId));
          } else if (newFrameRate === null && frameRate !== null) {
            dispatch(setFrameRate(frameRate, false, woMemfisId));
          } else {
            dispatch(showError(`Frame Rate not set`));
            return;
          }
        }

        lkfsData && dispatch(saveIngestLkfsData(woMemfisId, lkfsData));
      }
      if (onSetManualUpload) {
        onSetManualUpload(item, ingestData);
      } if (onStartIngestFromAssetManager) {
        onStartIngestFromAssetManager(ingestData);
      } if (showIngestSettings) {
        dispatch(setAddToWoIngestOperationTypes(ingestData));
        if (showFileSelection) {
          dispatch(changeStatusToAddFile('isFilesScreen', true));
        }
        this.handleClose(false, true);
      } else {
        dispatch(setIngestOperationTypes(ingestData));
      }
    };
    if (!officesWithEncPassword.length) {
      onSend();
    } else {
      let passwordInfo = '';
      if (officesWithEncPassword.length === 1) {
        passwordInfo = `${officesWithChangedEncPassword.length ? 'changed' : 'auto-generated'} encrypt password`;
      } else if (!officesWithChangedEncPassword.length) {
        passwordInfo = 'auto-generated encrypt passwords';
      } else if (officesWithEncPassword.length === officesWithChangedEncPassword.length) {
        passwordInfo = 'changed encrypt passwords';
      } else {
        passwordInfo = `changed (${OFFICE_SHORT_NAMES[officesWithChangedEncPassword[0]]}) and auto-generated (${OFFICE_SHORT_NAMES[officesWithNotChangedEncPassword[0]]}) encrypt passwords`;
      }
      confirmAlert({
        title: 'Are You Sure?',
        message: `Are you sure you want to send data with ${passwordInfo}?`,
        buttons: [{
          label: 'No',
        }, {
          label: 'Yes',
          onClick: onSend
        }]
      });
    }
  };

  handleBack = () => {
    const {dispatch, storageManager} = this.props;
    const {woSteps, showWoStepsAddToWo} = storageManager;
    if (woSteps && woSteps.length > 0 && !showWoStepsAddToWo) {
      dispatch(onGotoScreenToAddFile('isWoStepsScreen', null));
      dispatch(showWoStepsAddToWoModal(true));
      dispatch(showWoStepsModal(true));
    }

    this.handleClose(true, true);
  }

  handleClose = (isIngest, isClose) => {
    const {dispatch, onClose, showIngestSettings, lkfsModalState} = this.props;
    const {errorType, frameRate} = lkfsModalState;
    if (showIngestSettings && isIngest) {
      dispatch(changeStatusToAddFile('isIngestScreen', false));
      dispatch(setAddToWoIngestOperationTypes(null));
    }

    if (onClose) {
      onClose();
    } else if (isClose || (errorType === null && frameRate === null)) {
      if (isClose) {
        dispatch(clearFrameRateData());
      }
      dispatch(showIngestModal());
    }
  };

  componentWillUnmount() {
    this.handleClose();
  }

  renderCheckboxForStep(office, index, key, step) {
    const {storageManager} = this.props;
    let title = null;
    if (step.id === 32768) {
      // for XxHash Checksum
      title = storageManager.XxHashIssue;
    }

    return (
      <>
        <FormControl
          id={key}
          name={key}
          type="checkbox"
          disabled={!step.editable}
          checked={step.value}
          onChange={event => this.handleChange(office, index, event.target.checked)}
          title={title}
        />
        <ControlLabel htmlFor={key} title={title}>
          {step.label}
        </ControlLabel>
        {title && <WarningIcon className="warning-icon" title={title} />}
      </>
    );
  }

  openFrameRateModal = () => {
    const {dispatch} = this.props;
    dispatch(showFrameRateModal(true));
  }

  setNewFrameRate = (value) => {
    const {dispatch} = this.props;
    if (!/^-?(0|[1-9]\d*)(\.[0-9]{1,4})?(\/-?(0|[1-9]\d*)(\.[0-9]{1,4})?)?$/.test(value) || value === "0") {
      dispatch(setErrorNumberFrameRateValue(true));
    } else {
      dispatch(setErrorNumberFrameRateValue(false));
    }
    dispatch(setNewFrameRate(value));
  }

  hasLKFS = () => {
    const {ingestData: ingestOperationTypes} = this.state;
    let hasLKFS = false;
    if (ingestOperationTypes) {
      const keys = Object.keys(ingestOperationTypes);
      for (let key of keys) {
        const operationTypes = ingestOperationTypes[key];
        for (const step of operationTypes.steps) {
          if ([1, 2, 8192].indexOf(step.id) > -1 && step.value) {
            hasLKFS = true;
            break;
          }
        }
        if (hasLKFS) {
          break;
        }
      }
    }

    return hasLKFS;
  };

  openIngestConfigureAudioChannelSetsModal = () => {
    const {dispatch} = this.props;
    dispatch(showIngestConfigChannelSetsModal(true));
  }

  renderLkfsControls = () => {
    const {lkfsModalState} = this.props;
    const {errorType, newFrameRate, frameRate, isErrorNumberFrameRate, errorQcProject, isEnable} = lkfsModalState;
    const className = ((errorType !== null && errorType !== "success") && newFrameRate === null) || isErrorNumberFrameRate ? "error" : "";
    const btnClassName = ((errorType !== null && errorType !== "success") && newFrameRate === null) || isErrorNumberFrameRate ? 'btn-danger' : 'bg-info';

    const hasLKFS = this.hasLKFS();

    if (!hasLKFS || !isEnable) {
      return null;
    }

    return (
      <>
        <PathFieldStyledAdv color="black">
          <label>Frame Rate:</label>
          <div className="value no-monospace">
            <input
              type='text'
              className={className}
              value={newFrameRate !== null ? newFrameRate : frameRate}
              onChange={(e) => this.setNewFrameRate(e.target.value)}
            />
            &nbsp;
            {errorType !== null && errorType !== "success" ?
              <button
                type="button"
                className={'btn ' + btnClassName}
                onClick={() => this.openFrameRateModal()}
                title="See error details"
              >
                explain
              </button> : null
            }
            {isErrorNumberFrameRate && !errorQcProject ?
              <p className="bg-danger">Frame rate must be a number</p>
              : null
            }
          </div>
        </PathFieldStyledAdv>
        {errorQcProject && (
          <PathFieldStyledAdv>
            <p className="bg-danger fr-determ">Frame rate can not be determined</p>
          </PathFieldStyledAdv>
        )}
        <button
          type="button"
          className='btn btn-default'
          onClick={() => this.openIngestConfigureAudioChannelSetsModal()}
          title="Configure audio channel sets"
        >
          Configure audio channel sets
        </button>
      </>
    );
  };

  render() {
    const {isSending, isLoading, workOrder, item, fromLinkToWo, onSetManualUpload, showIngestSettings, lkfsModalState} = this.props;
    const {ingestData, originalEncPasswords} = this.state;
    const offices = Object.keys(ingestData).sort((a, b) => ingestData[a].is_main ? -1 : ingestData[b].is_main ? 1 : 0);
    const {isLKFSSubmit, isErrorNumberFrameRate} = lkfsModalState;

    const hasLKFS = this.hasLKFS();

    return (
      <RndModal
        show={true}
        onHide={() => this.handleClose(false, true)}
        backdrop="static"
        enforceFocus={false}
        >
        <Modal.Header>
          <Modal.Title>
            {`${typeof fromLinkToWo === 'boolean' ? `${fromLinkToWo ? 'Link' : 'Add'} to WO: ` : ''}Ingest Options`}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container-fluid">
            {isLoading ?
                <div>
                  <Loader/>
                  <ReportBugButton isForModal className="loader-report-bug-btn"/>
                </div> : null}
            <PathFieldStyledAdv>
              <label>Content:</label>
              <TextEllipsisAdvanced className="value" data={getValueForOS(item, 'key')}/>
            </PathFieldStyledAdv>
            <PathFieldStyledAdv color="black">
              <label>Work Order:</label>
              <div className="value no-monospace">{buildWOInfo(workOrder || {})}</div>
            </PathFieldStyledAdv>
            <div>Please select ingest actions:</div>
            {
              !offices.length ? 'No data' :
                offices.map(office => {
                  const encPassword = Array.isArray(ingestData[office]) ? null : ingestData[office].enc_password;
                  const steps = Array.isArray(ingestData[office]) ? ingestData[office] : ingestData[office].steps;
                  return (
                    <div className="office" key={`office-${office}`}>
                      <StyledOfficeName>{OFFICE_NAMES[office] || `"${office}" office`}:</StyledOfficeName>
                      {
                        (!Array.isArray(steps) || !steps.length) ? 'No steps' : steps.map((step, index) => {
                          const key = `checkbox-${office}-${index}`;
                          const withEncPassword = !!(originalEncPasswords[office] || encPassword) && step.label === 'Encrypt content' && step.value;
                          const isInvalidPassword = withEncPassword ? this.isInvalidEncPassword(office) : null;
                          const isVisiblePassword = withEncPassword ? this.isVisibleEncPassword(office) : null;
                          return (
                            <FormGroupStyled
                              className={`checkbox${withEncPassword ? ' with-enc-password' : ''}`}
                              key={key}
                            >
                              {
                                withEncPassword ?
                                  <>
                                    <div>
                                      {this.renderCheckboxForStep(office, index, key, step)}
                                    </div>
                                    <FormGroup
                                      className="enc-password"
                                      validationState={isInvalidPassword ? 'error' : null}
                                    >
                                      <ControlLabel htmlFor={`${key}-password`}>
                                        Encrypt password
                                        <OverlayTrigger
                                          placement="right"
                                          overlay={
                                            <Popover id={`${key}-password-popover`} className="filter-popover">
                                              The new password you select can contain digits (0-9) and letters (A-Z, a-z).
                                              <br/>
                                              The password must at least be {ENC_PASSWORD_MIN_LENGTH} characters long.
                                            </Popover>
                                          }
                                        >
                                          <i className="fas fa-question-circle"/>
                                        </OverlayTrigger>
                                      </ControlLabel>
                                      <FormControl
                                        id={`${key}-password`}
                                        name={`${key}-password`}
                                        type={isVisiblePassword ? 'text' : 'password'}
                                        defaultValue={encPassword || ''}
                                        onChange={event => this.handleChangeEncPassword(office, event.target.value)}
                                      />
                                      <i
                                        className={`far fa-eye${isVisiblePassword ? '' : '-slash'}`}
                                        onClick={() => this.handleToggleEncPasswordVisibility(office, !isVisiblePassword)}
                                      />
                                    </FormGroup>
                                  </> : this.renderCheckboxForStep(office, index, key, step)
                              }
                            </FormGroupStyled>
                          );
                        })
                      }
                    </div>
                  );
                })
            }
            {this.renderLkfsControls()}
          </div>
        </Modal.Body>
        <Modal.Footer>
          { showIngestSettings ?
            <>
              <Button bsStyle="default" onClick={this.handleBack} disabled={isLoading || isSending}>
                Back
              </Button>
            </>
            : null
          }
          <Button bsStyle="primary" onClick={this.handleSend} disabled={isLoading || isSending || (!isLKFSSubmit && hasLKFS) || (hasLKFS && isErrorNumberFrameRate)}>
            {
              showIngestSettings ?
                'Continue' :
                (onSetManualUpload ? 'Confirm' : 'Begin Ingest')
            }
          </Button>
          <Button bsStyle="default" onClick={() => this.handleClose(false, true)} disabled={isLoading || isSending}>
            Cancel
          </Button>
        </Modal.Footer>
      </RndModal>
    );
  }
}

const StyledOfficeName = styled.div`
  margin: 14px 0 0 20px;
  font-size: 12px;
  font-weight: bold;
`;

const FormGroupStyled = styled(FormGroup)`
  margin-bottom: 6px;
  .control-label {
    font-size: 10px;
    margin-left: 20px;
    padding: 0;
  }
  .form-control {
    height: auto;
    width: auto;
    cursor: pointer;
    margin-left: 0 !important;
  }
  input[disabled] + label {
    cursor: default !important;
  }

  &.with-enc-password {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .enc-password {
      margin: 0;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      position: relative;
      label {
        margin: 5px 5px 0 0;
        cursor: default;
      }
      input {
        padding-left: 8px;
        padding-right: 30px;
        height: 25px;
        cursor: text;
      }
      i[class*="fa-eye"] {
        position: absolute;
        top: 0;
        right: 6px;
        line-height: 25px;
        width: 18px;
        text-align: center;
        cursor: pointer;
        opacity: 0.45;
        :hover {
          opacity: 0.6;
        }
      }
      i[class*="fa-question"] {
        margin-left: 2px;
        color: #333 !important;
        opacity: 0.8;
      }
    }
  }

  .warning-icon {
    color: orange;
    vertical-align: bottom;
    margin-left: 3px;
  }
`;

IngestModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  storageManager: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  workOrder: PropTypes.object,
  fromLinkToWo: PropTypes.bool,
  item: PropTypes.object.isRequired,
  isSending: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool,
  onSetManualUpload: PropTypes.func,
  onStartIngestFromAssetManager: PropTypes.func,
  onClose: PropTypes.func,
  lkfsModalState: PropTypes.object
};

export default IngestModal;
